export const MAX_FILE_SIZE_BYTES = 200 * 1024; // 200 KB
